import React from 'react';

import { useMoveLessonOverviewItemMutation, useUpdateLessonMutation } from '../lessonsApi';

import type { Lesson } from '@/shared/types/lesson';
import type { OverviewItem } from '@/shared/types/overview';
import type { StoredStandard } from '@/shared/types/customStandard';
import type { ReorderPlacement } from '@/shared/utils/reorder';
import { OverviewCard } from '@/features/courses/components/OverviewCard';

interface LessonOverviewCardProps {
  lesson: Lesson;
  canEdit: boolean;
  parentScope?: StoredStandard[];
}

export const LessonOverviewCard: React.FC<LessonOverviewCardProps> = ({
  lesson,
  canEdit,
  parentScope,
}) => {
  const [updateLesson, { isLoading: isUpdating }] = useUpdateLessonMutation();
  const [moveOverviewItem] = useMoveLessonOverviewItemMutation();

  const handleMoveOverviewItem = (itemId: string, placement: ReorderPlacement) =>
    moveOverviewItem({ lessonId: lesson.id, itemId, placement }).unwrap();

  const handleSaveOverview = async (overview: OverviewItem[]) => {
    await updateLesson({
      id: lesson.id,
      content: { ...(lesson.content ?? {}), overview, schemaVersion: '1' },
    }).unwrap();
  };

  return (
    <OverviewCard
      title="Lesson Overview"
      entityName="lesson"
      items={lesson.content?.overview ?? []}
      canEdit={canEdit}
      isUpdating={isUpdating}
      onSave={handleSaveOverview}
      onMove={handleMoveOverviewItem}
      ownerId={lesson.owner_id}
      parentScope={parentScope}
      allowAllToggle
      scopeLabel="unit"
      sx={{ mb: 2 }}
    />
  );
};

export default LessonOverviewCard;
